import React from 'react';

type Props = {
  className?: string;
};

const CallIcon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30" className={className}>
    <path
      fill="#DF2429"
      d="M9.6 22.5l5.4-5.4 5.4 5.4 2.1-2.1-5.4-5.4 5.4-5.4-2.1-2.1-5.4 5.4-5.4-5.4-2.1 2.1 5.4 5.4-5.4 5.4 2.1 2.1zM15 30c-2.075 0-4.025-.394-5.85-1.181-1.825-.788-3.413-1.857-4.763-3.206-1.35-1.35-2.418-2.938-3.206-4.763C.394 19.025 0 17.075 0 15c0-2.075.394-4.025 1.181-5.85.788-1.825 1.857-3.413 3.207-4.763 1.35-1.35 2.937-2.418 4.762-3.206C10.975.394 12.925 0 15 0c2.075 0 4.025.394 5.85 1.181 1.825.788 3.412 1.857 4.762 3.207 1.35 1.35 2.42 2.937 3.207 4.762C29.606 10.975 30 12.925 30 15c0 2.075-.394 4.025-1.181 5.85-.788 1.825-1.857 3.412-3.206 4.762-1.35 1.35-2.938 2.42-4.763 3.207C19.025 29.606 17.075 30 15 30zm0-3c3.35 0 6.188-1.163 8.512-3.488C25.837 21.188 27 18.35 27 15c0-3.35-1.163-6.188-3.488-8.512C21.188 4.162 18.35 3 15 3c-3.35 0-6.188 1.162-8.512 3.487C4.162 8.813 3 11.65 3 15c0 3.35 1.162 6.188 3.487 8.512C8.813 25.837 11.65 27 15 27z"
    ></path>
  </svg>
);

export default CallIcon;
